import { render } from "./clientesPorColaborador.vue?vue&type=template&id=fbce2c20"
import script from "./clientesPorColaborador.vue?vue&type=script&lang=js"
export * from "./clientesPorColaborador.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__